const RepeatBookingIcon = ({ size = 15, color = "#3C2212", ...props }) => (
    <svg
      width={size}
      height={size * (14 / 15)}
      viewBox="0 0 15 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.5312 0.0625C14.8125 0.1875 15 0.46875 15 0.75V5.25C15 5.6875 14.6562 6 14.25 6H9.75C9.4375 6 9.15625 5.84375 9.03125 5.5625C8.9375 5.28125 9 4.9375 9.21875 4.75L11.0625 2.875C10.0938 2.03125 8.84375 1.5 7.5 1.5C5.0625 1.5 2.875 3.15625 2.21875 5.46875C2.09375 5.875 1.6875 6.09375 1.28125 6C0.875 5.875 0.65625 5.46875 0.75 5.0625C1.625 2.09375 4.40625 0 7.5 0C9.25 0 10.875 0.6875 12.125 1.8125L13.7188 0.25C13.9062 0.03125 14.25 -0.03125 14.5312 0.0625ZM13.6875 8.03125C14.0938 8.15625 14.3125 8.5625 14.2188 8.96875C13.3438 11.9375 10.5938 14 7.5 14C5.71875 14 4.09375 13.3438 2.84375 12.2188L1.25 13.7812C1.125 13.9375 0.9375 14 0.75 14C0.625 14 0.53125 14 0.4375 13.9688C0.15625 13.8438 0 13.5625 0 13.25V8.75C0 8.34375 0.3125 8 0.75 8H5.25C5.53125 8 5.8125 8.1875 5.9375 8.46875C6.03125 8.75 5.96875 9.09375 5.75 9.28125L3.90625 11.1562C4.875 12 6.125 12.5 7.5 12.5C9.90625 12.5 12.0938 10.875 12.7812 8.5625C12.875 8.15625 13.3125 7.9375 13.6875 8.03125Z"
        fill={color}
      />
    </svg>
  );
  
  export default RepeatBookingIcon;
  